import api from 'services/api';

// ── Importação IXC / Pacto ───────────────────────────────────
// O backend resolve a empresa pelo tenant. MOV/XT usam sua fonte IXC
// (banco ou MCP) quando dp.funcionarios estiver habilitada; caso contrário,
// preservam o webhook legado. MOV Fit continua na Pacto por unidade.

// Empresas simples (uma unidade)
const IXC_SEGMENTOS = {
  'MOV Fibra': { segmento: 'funcionarios',     empresa: 'MOV FIBRA' },
  'XT Fibra':  { segmento: 'funcionarios',     empresa: 'XT FIBRA'  },
};

// MOV Fit: múltiplas unidades
export const MOV_FIT_UNIDADES = [
  { id: 'santarem24',     label: 'Santarém 24h',           segmento: 'santarem24/funcionarios'            },
  { id: 'nova-republica', label: 'Nova República Express', segmento: 'nova-republica-express/funcionarios' },
  { id: 'medicilandia',   label: 'Medicilândia',           segmento: 'medicilandia/funcionarios'           },
  { id: 'itaituba',       label: 'Itaituba',               segmento: 'itaituba/funcionarios'               },
];

export const isMovFit = (companyName = '') =>
  companyName.toLowerCase().includes('fit');

export const listarFuncionariosIXC = async (companyName = 'MOV Fibra', unidadeId = null) => {
  let segmento;
  let empresa;

  if (isMovFit(companyName) && unidadeId) {
    const unidade = MOV_FIT_UNIDADES.find((u) => u.id === unidadeId);
    if (!unidade) throw new Error('Unidade MOV Fit não encontrada');
    segmento = unidade.segmento;
    empresa  = unidade.label;
  } else {
    const cfg = IXC_SEGMENTOS[companyName] ?? IXC_SEGMENTOS['MOV Fibra'];
    segmento = cfg.segmento;
    empresa  = cfg.empresa;
  }

  // O backend escolhe a fonte autorizada; a rota e o contrato são preservados.
  const res = await api.post('/dp/funcionarios/ixc', { segmento, empresa });
  return res.data.data ?? {};
};

// ── Funcionários ────────────────────────────────────────────
export const listarFuncionarios = (params = {}) => api.get('/dp/funcionarios', { params });
export const buscarFuncionario = (id) => api.get(`/dp/funcionarios/${id}`);
export const criarFuncionario = (dados) => api.post('/dp/funcionarios', dados);
export const atualizarFuncionario = (id, dados) => api.put(`/dp/funcionarios/${id}`, dados);

// ── Documentos do Funcionário ───────────────────────────────
export const listarDocumentos = (funcId) => api.get(`/dp/funcionarios/${funcId}/documentos`);
export const uploadDocumento = (funcId, formData) => api.post(`/dp/funcionarios/${funcId}/documentos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const excluirDocumento = (funcId, docId) => api.delete(`/dp/funcionarios/${funcId}/documentos/${docId}`);
export const downloadDocumento = (funcId, docId) => api.get(`/dp/funcionarios/${funcId}/documentos/${docId}/download`, { responseType: 'blob' });

// ── Cargos ──────────────────────────────────────────────────
export const listarCargos = (params = {}) => api.get('/dp/cargos', { params });
export const criarCargo = (dados) => api.post('/dp/cargos', dados);
export const atualizarCargo = (id, dados) => api.put(`/dp/cargos/${id}`, dados);

// ── Departamentos ───────────────────────────────────────────
export const listarDepartamentos = (params = {}) => api.get('/dp/departamentos', { params });
export const criarDepartamento = (dados) => api.post('/dp/departamentos', dados);
export const atualizarDepartamento = (id, dados) => api.put(`/dp/departamentos/${id}`, dados);

// ── Lotações ────────────────────────────────────────────────
export const listarLotacoes = (params = {}) => api.get('/dp/lotacoes', { params });
export const criarLotacao = (dados) => api.post('/dp/lotacoes', dados);

// ── Rubricas ────────────────────────────────────────────────
export const listarRubricas = (params = {}) => api.get('/dp/rubricas', { params });
export const criarRubrica = (dados) => api.post('/dp/rubricas', dados);

// ── Admissões ───────────────────────────────────────────────
export const listarAdmissoes = (params = {}) => api.get('/dp/admissoes', { params });
export const criarAdmissao = (dados) => api.post('/dp/admissoes', dados);
export const buscarAdmissao = (id) => api.get(`/dp/admissoes/${id}`);
export const atualizarAdmissao = (id, dados) => api.put(`/dp/admissoes/${id}`, dados);
export const concluirAdmissao = (id) => api.post(`/dp/admissoes/${id}/concluir`);
export const cancelarAdmissao = (id) => api.post(`/dp/admissoes/${id}/cancelar`);

// ── Folha de Pagamento ──────────────────────────────────────
export const listarFolhas = (params = {}) => api.get('/dp/folhas', { params });
export const criarFolha = (dados) => api.post('/dp/folhas', dados);
export const calcularFolha = (id) => api.post(`/dp/folhas/${id}/calcular`);
export const fecharFolha = (id) => api.post(`/dp/folhas/${id}/fechar`);
export const getHolerite = (folhaId, funcId) => api.get(`/dp/folhas/${folhaId}/holerite/${funcId}`);
export const getResumo = (folhaId) => api.get(`/dp/folhas/${folhaId}/resumo`);
export const salvarObservacao = (folhaId, dados) => api.patch(`/dp/folhas/${folhaId}/observacao`, dados);
export const salvarObservacaoResumo = (funcId, dados) => api.patch(`/dp/funcionarios/${funcId}/observacao-resumo`, dados);
export const atualizarFolhaItem = (itemId, dados) => api.patch(`/dp/folha-itens/${itemId}`, dados);

// ── iFood ───────────────────────────────────────────────────
export const atualizarIfoodFixo = (funcId, dados) => api.patch(`/dp/funcionarios/${funcId}/ifood-fixo`, dados);
export const salvarIfoodBonificacao = (funcId, dados) => api.post(`/dp/funcionarios/${funcId}/ifood-bonificacao`, dados);

// ── Adiantamentos / Vales ───────────────────────────────────
export const listarAdiantamentos = (params = {}) => api.get('/dp/adiantamentos', { params });
export const criarAdiantamento = (dados) => api.post('/dp/adiantamentos', dados);
export const atualizarAdiantamento = (id, dados) => api.patch(`/dp/adiantamentos/${id}`, dados);
export const excluirAdiantamento = (id) => api.delete(`/dp/adiantamentos/${id}`);

// ── Afastamentos ────────────────────────────────────────────
export const listarAfastamentos = (params = {}) => api.get('/dp/afastamentos', { params });
export const criarAfastamento = (dados) => api.post('/dp/afastamentos', dados);
export const registrarRetorno = (id, dados) => api.post(`/dp/afastamentos/${id}/retorno`, dados);

// ── Banco de Horas / Cartão de Ponto ────────────────────────
export const listarBancoHoras = (params = {}) => api.get('/dp/banco-horas', { params });
export const criarBancoHoras = (dados) => api.post('/dp/banco-horas', dados);
export const excluirBancoHoras = (id) => api.delete(`/dp/banco-horas/${id}`);
export const saldoGeral = (params = {}) => api.get('/dp/banco-horas/saldo-geral', { params });
export const saldoFuncionario = (funcId) => api.get(`/dp/banco-horas/saldo/${funcId}`);

// ── Rescisões ───────────────────────────────────────────────
export const listarRescisoes = (params = {}) => api.get('/dp/rescisoes', { params });
export const criarRescisao = (dados) => api.post('/dp/rescisoes', dados);
export const buscarRescisao = (id) => api.get(`/dp/rescisoes/${id}`);

// ── Fiscal ──────────────────────────────────────────────────
export const listarDocumentosFiscais = (params = {}) => api.get('/dp/fiscal/documentos', { params });
export const buscarDocumentoFiscal = (id) => api.get(`/dp/fiscal/documentos/${id}`);
export const excluirDocumentoFiscal = (id) => api.delete(`/dp/fiscal/documentos/${id}`);
export const importarDocumentoFiscal = (formData) => api.post('/dp/fiscal/importar', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const classificarDocumentoFiscal = (id, dados) => api.put(`/dp/fiscal/documentos/${id}/classificar`, dados);
export const downloadXmlFiscal = (id) => api.get(`/dp/fiscal/documentos/${id}/xml`, { responseType: 'blob' });
export const resumoFiscal = (params = {}) => api.get('/dp/fiscal/documentos/resumo', { params });

// ── eSocial ─────────────────────────────────────────────────
export const listarEventosEsocial = (params = {}) => api.get('/dp/esocial/eventos', { params });
export const gerarEventoEsocial = (tipo) => api.post(`/dp/esocial/gerar/${tipo}`);
export const regenerarEvento = (id) => api.post(`/dp/esocial/eventos/${id}/regenerar`);
export const downloadXmlEvento = (id) => api.get(`/dp/esocial/eventos/${id}/xml`, { responseType: 'blob' });

// ── Dashboard ───────────────────────────────────────────────
export const dashboardDP = () => api.get('/dp/dashboard');
